module.exports = __webpack_public_path__ + "img/ctwy-4.8ab57569.jpg";